export default "/images/c429bd922fbc755cdea83f8a3d957259.avif";